import SettingsHomePage, { columns1, columns2, columns3, columns4, columns5 } from './SettingsHomePage';

const settingsLinks = [...columns1, ...columns2, ...columns3, ...columns4, ...columns5];

export { settingsLinks };
export default SettingsHomePage;
